<template>
    <div class="col-lg-5 col-md-7">
        <div class="">
            <div class=" px-lg-5 pt-lg-5 pb-lg-2">
                <div class="login-header text-center mb-4">{{ $t('login') }}</div>
                <base-alert type="danger" v-if="error">{{error}}</base-alert>
                <base-alert type="primary" v-if="codeRequested">{{ $t('at_phone_') }}
                    <strong>{{login}}</strong> {{ $t('_send_sms_with_code_site') }}
                </base-alert>
                <div role="form" v-if="!codeRequested">

                    <base-input class=" mb-3"
                                ref="login"
                                :placeholder="`${$t('enter_phone')}*`"
                                :error="fieldError('login')"
                                addon-left-icon="ni ni-mobile-button"
                                @keyup.enter.prevent="requestCode"
                                v-model="login">
                    </base-input>

                    <div class="text-center">
                        <base-button
                                data-model="user"
                                data-action="request-login-code"
                                :data-label="$t('continue')"
                                :disabled="!login "
                                class="my-4 px-5 py-3 login-btn" @click="requestCode">
                            {{ $t('continue') }}
                        </base-button>
                    </div>
                </div>
                <div role="form" v-else>
                    <base-input class="input-group-alternative mb-3"
                                ref="code"
                                :placeholder="$t('enter_sms_code')"
                                :error="fieldErrors(['code', 'login', 'username'])"
                                addon-left-icon="ni ni-mobile-button"
                                @keyup.enter.prevent="confirmCode"
                                v-model="code">
                    </base-input>
                    <div class="text-center repeat-code-notice" v-if="timerSeconds > 0">
                        {{ $t('request_code_again_through_') }} {{ timerSeconds }}&nbsp;{{ secondsPlural(timerSeconds) }}
                    </div>
                    <div class="text-center repeat-code-again" v-if="timerSeconds <= 0" @click="requestCode">
                        {{ $t('request_code_again') }}
                    </div>
                    <div class="text-center">
                        <base-button
                                data-model="user"
                                data-action="confirm-login-code"
                                :data-label="$t('confirm')"
                                class="my-4 px-5 py-3 login-btn" @click="confirmCode">
                            {{ $t('confirm') }}
                        </base-button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import userApi from "../../data/UserApi";
    import JwtService from "../../data/jwt.service";

    export default {
        name: "SmsLogin",
        props: {
            defaultLogin: String,
        },
        data() {
            return {
                login: '',
                code: '',

                error: null,
                fieldsErrors: [],
                loading: false,

                codeRequested: false,
                codeRequestedAt: null,

                loginedUser: null,

                timerSeconds: null,
                timer: null,
            }
        },

        mounted() {
            if (this.defaultLogin) {
                this.login = this.defaultLogin
                this.requestCode()
            } else {
                this.$refs.login.$el.querySelector('input').focus()
            }
        },

        watch: {
            timerSeconds(seconds) {
                if (seconds <= 0) this.stopTimer()
            },
        },

        methods: {
            requestCode() {
                if (this.login) {
                    this.code = ''
                    this.error = null
                    this.fieldsErrors = []
                    this.codeRequested = false
                    this.startTimer(60)
                    userApi.requestLoginCode(this.login)
                        .then(response => {
                            this.loading = false
                            this.$emit('requested', response);
                            this.codeRequested = true
                            this.$nextTick(() => this.$refs.code.$el.querySelector('input').focus())
                        })
                        .catch(error => {
                            let data = error.response.data
                            if (error.response.status === 422) {
                                this.fieldsErrors = data
                            } else {
                                this.error = this.pretty(data)
                            }
                            this.loading = false
                        })
                }
            },

            confirmCode() {
                this.error = null
                this.fieldsErrors = []
                userApi.confirmLoginCode(this.code, this.login, this.username)
                    .then(response => {
                        this.loading = false

                        this.loginedUser = response.user
                        JwtService.saveUser(this.loginedUser)
                        userApi.pushUserContext()
                        this.loading = false
                        if ('return' in this.$route.query) this.$router.push(this.$route.query.return)
                        else window.location.href = '/'

                    })
                    .catch(error => {
                        let data = error.response.data
                        if (error.response.status === 422) {
                            this.fieldsErrors = data
                        } else {
                            this.error = this.pretty(data)
                        }
                        this.loading = false
                    })
            },

            startTimer(start) {
                this.timerSeconds = start
                this.timer = setInterval(() => {
                    this.timerSeconds = this.timerSeconds - 1
                }, 1000)
            },

            stopTimer() {
                clearTimeout(this.timer)
            },

            destroyed() {
                this.stopTimer()
            },

            fieldError(fieldName) {
                let errors = []
                if (this.fieldsErrors) {
                    this.fieldsErrors.filter(field => {
                        if (field.field === fieldName) {
                            errors.push(field.message)
                        }
                    })
                }
                if (errors.length > 0)
                    return errors.join(', ')
                return null
            },

            fieldErrors(fieldNames) {
                let errors = []
                if (this.fieldsErrors) {
                    this.fieldsErrors.filter(field => {
                        if (fieldNames.indexOf(field.field) >= 0) {
                            errors.push(field.message)
                        }
                    })
                }
                if (errors.length > 0)
                    return errors.join(', ')
                return null
            },

            pretty(value) {
                if (value.message) {
                    return value.message
                }
                return JSON.stringify(value, null, 2)
            },

            secondsPlural(seconds) {
                return this.plural([this.$t('one_second'), this.$t('two_second'), this.$t('few_second')], seconds)
            },

            plural(forms, n) {
                let idx;
                // @see http://docs.translatehouse.org/projects/localization-guide/en/latest/l10n/pluralforms.html
                if (n % 10 === 1 && n % 100 !== 11) {
                    idx = 0; // many
                } else if (n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20)) {
                    idx = 1; // few
                } else {
                    idx = 2; // one
                }
                return forms[idx] || '';
            },

        },

    }
</script>

<style scoped>
    .repeat-code-notice, .repeat-code-again {
        color: white;
        font-size: 13px;
    }

    .repeat-code-again {
        cursor: pointer;
        text-decoration: underline;
    }

    .bg-login-default .input-group.input-group-alternative.has-danger .form-control {
        padding-right: 38px;
        border-top-right-radius: 0.375rem;
        border-bottom-right-radius: 0.375rem;
    }
</style>
